module.exports = __webpack_public_path__ + "img/gal_31.531c9137.png";